module.exports = __webpack_public_path__ + "static/media/add-documents.346beca7.svg";